import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject = new BehaviorSubject<any>(null);
  public currentUser$ = this.currentUserSubject.asObservable();

  constructor(private http: HttpClient) {
    // Cek token saat inisialisasi service
    const token = localStorage.getItem('token');
    if (token) {
      this.decodeToken(token);
    }
  }

  // Login Google
  loginWithGoogle(idToken: string): Observable<any> {
    return this.http.post<any>(`/api/login_google`, { idToken })
      .pipe(
        tap(response => {
          if (response.token) {
            localStorage.setItem('token', response.token);
            this.decodeToken(response.token);
          }
        })
      );
  }

    // Login Facebook
    loginWithFacebook(accessToken: string): Observable<any> {
      return this.http.post<any>(`/api/login_facebook`, { accessToken })
        .pipe(
          tap(response => {
            if (response.token) {
              localStorage.setItem('token', response.token);
              this.decodeToken(response.token);
            }
          })
        );
    }


      // Kirim OTP ke WhatsApp
  sendOtp(whatsapp_number: string): Observable<any> {
    return this.http.post<any>(`/api/send-otp`, { whatsapp_number });
  }

  sendOtp2(whatsapp_number: string, email_pelanggan : string): Observable<any> {
    return this.http.post<any>(`/api/send-otp2`, { whatsapp_number, email_pelanggan });
  }


  // Verifikasi OTP untuk WhatsApp
  verifyOtp2(whatsapp_number: string, email_pelanggan: string, verification_code: string): Observable<any> {
    return this.http.post<any>(`/api/verify-otp2`, { whatsapp_number, email_pelanggan, verification_code }); 
  }
  

  // Verifikasi OTP untuk WhatsApp
  verifyOtp(whatsapp_number: string, verification_code: string): Observable<any> {
    return this.http.post<any>(`/api/verify-otp`, { whatsapp_number, verification_code })
      .pipe(
        tap(response => {
          if (response.token) {
            localStorage.setItem('token', response.token);
            this.decodeToken(response.token);
          }
        })
      );
  }

  registerWithWhatsApp(whatsapp_number: string, email: string, name: string): Observable<any> {
    return this.http.post<any>(`/api/regis-wa`, { whatsapp_number, email, name});
  }


  cek_email(email: string): Observable<any> {
    return this.http.post<any>(`/api/cek_email`, {email});
  }

  
  get_id(email: string): Observable<any> {
    return this.http.post<any>(`/api/getIdPelanggan`, {email});
  }


  registerWithEmail(dt : any): Observable<any> {
    return this.http.post<any>(`/api/regis-email`,dt)
    .pipe(
      tap(response => {
        if (response.token) {
          localStorage.setItem('token', response.token);
          this.decodeToken(response.token);
        }
      })
    );
  }


  login_email(dt : any): Observable<any> {
    return this.http.post<any>(`/api/login_pelanggan`,dt)
    .pipe(
      tap(response => {
        if (response.token) {
          localStorage.setItem('token', response.token);
          this.decodeToken(response.token);
        }
      })
    );
  }

  // Decode token dan set current user
  private decodeToken(token: string) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      this.currentUserSubject.next({
        id: payload.id,
        email: payload.email,
        role: payload.role
      });
    } catch (error) {
      console.error('Error decoding token', error);
      this.logout();
    }
  }

  // Cek apakah user sudah login
  isLoggedIn(): boolean {
    return !localStorage.getItem('authToken');
  }

  // Logout
  logout() {
    localStorage.removeItem('authToken');
    this.currentUserSubject.next(null);
  }

  // Getter untuk current user
  getCurrentUser() {
    return this.currentUserSubject.getValue();
  }

  getPelangganByEmail(email:string): Observable<any> {
    return this.http.get<any>(`/api/pelanggan/account/${email}`);
  }

  getPelangganPass(email:string): Observable<any> {
    return this.http.get<any>(`/api/pelanggan/account_f/${email}`);
  }

  //checkout
  private badgeSubject = new BehaviorSubject<boolean>(false);
  badge$ = this.badgeSubject.asObservable();

  checkLocalStorage(): void {
    const bookingData = localStorage.getItem('formattedBookingData');
    this.badgeSubject.next(!!bookingData);
  }

  addBookingData(): void {
    localStorage.setItem('formattedBookingData', JSON.stringify({ test: true }));
    this.checkLocalStorage();
  }

  removeBookingData(): void {
    localStorage.removeItem('formattedBookingData');
    this.checkLocalStorage();
  }


  private redirectUrl: string | null = null;

  isLoggedIn2(): boolean {
    const token = localStorage.getItem('user_pelanggan'); // Contoh token autentikasi
    return !!token; // Jika token ada, pengguna dianggap login
  }

  // Simpan rute asal
  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }

  // Ambil rute asal
  getRedirectUrl(): string | null {
    return this.redirectUrl;
}

validateOldPassword(id: number, oldPassword: string) {
  return this.http.post<{ valid: boolean }>(`/api/cek_passPelanggan`, {
    id,
    oldPassword,
  });
}

updatePelanggan(id: number, data: FormData): Observable<any> {
  return this.http.put(`/api/pelanggan/update/${id}`, data);
}


checkWhatsAppNumber(phone: string, id: number) {
  return this.http.get<any>(`/api/check-whatsapp-number?phone=${phone}&id=${id}`);
}

updatePhoneNumber(email: string, phone: string) {
  return this.http.post(`/api/update-phone-number`, { email, phone });
}

}
